import { render, staticRenderFns } from "./Scaffold.vue?vue&type=template&id=4e02f1a6&scoped=true&"
import script from "./Scaffold.vue?vue&type=script&lang=ts&"
export * from "./Scaffold.vue?vue&type=script&lang=ts&"
import style0 from "./Scaffold.vue?vue&type=style&index=0&id=4e02f1a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e02f1a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VMain,VProgressCircular,VRow,VSpacer})
